import client from '@services/client';

export const addDevelopAccount = async (userId: string, environment: string) => {
  return client.api.developAccountControllerAddDevelopAccount({ userId, environment });
};
